/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchResidents = /* GraphQL */ `
  query SearchResidents($pagination: PaginationInput, $query: String!) {
    searchResidents(pagination: $pagination, query: $query) {
      items {
        id
        residentId
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          spaceCode
          state
          type
          zipCode
        }
        insuranceAdoption {
          description
          status
        }
        policyType
        community {
          ctmhcId
          integrationId
          integrationType
          isActive
          legalEntityCommunityOwnerId
          name
          portfolio {
            id
            integrationId
            integrationType
            isActive
            name
          }
          displayId
          propertyId
        }
        createdAt
        updatedAt
        email
        phoneNumber
        isCurrentResident
        isPermanentlyExcluded
        wasOptedIn
        moveInDate
        moveOutDate
        sos
        isNariWorkflowApplicable
        lease {
          addendumDate
          startDate
          endDate
          description
        }
        leaseRequirements {
          animalLiabilityLimit
          leaseLimit
          medicalPaymentsLimit
        }
        policyholderLocator
        coverages {
          id
          agencyAddress
          agencyEmail
          agencyName
          agencyPhoneNumber
          annualCost
          coverageDetails {
            occupancy
            manufacturer
            homeType
            modelYear
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            homeCoverageLimit
            otherStructuresLimit
            personalLiabilityLimit
            premisesLiabilityLimit
            personalPropertyLimit
            residentLiabilityLimit
            standardDeductibleLimit
            medicalPaymentsLimit
          }
          createdAt
          documents {
            id
            name
            description
          }
          events {
            id
            type
            date
            eventData {
              agencyName
              agencyAddress
              agencyPhoneNumber
              agencyEmail
              isInternalSale
              insuranceCarrierName
              isActive
              coverageDetails {
                occupancy
                manufacturer
                homeType
                modelYear
                animalLiabilityLimit
                blanketRentalResidentLiabilityLimit
                homeCoverageLimit
                otherStructuresLimit
                personalLiabilityLimit
                premisesLiabilityLimit
                personalPropertyLimit
                residentLiabilityLimit
                standardDeductibleLimit
                medicalPaymentsLimit
              }
              policyId
              policyDescription
              termEffectiveDate
              termEndDate
              annualCost
            }
          }
          insuranceCarrierName
          isActive
          isInternalSale
          policyCancellationEffectiveDate
          policyCancellationReason
          policyDescription
          policyEffectiveDate
          policyEndDate
          policyEndReason
          policyId
          policyIssuedDate
          policyStatus
          policyType
          updatedAt
          updatedBy
        }
        physicalMailNotificationEvents {
          id
          additionalData
          eventType
          eventDate
        }
      }
      pagination {
        from
        size
        total
      }
    }
  }
`;
export const getReviewDetails = /* GraphQL */ `
  query GetReviewDetails($id: ID!) {
    getReviewDetails(id: $id) {
      id
      startedAt
      startReason
      endedAt
      endReason
      expectedEndDate
    }
  }
`;
export const getResidents = /* GraphQL */ `
  query GetResidents(
    $pagination: PaginationInput
    $sorting: GetResidentsSortByInput
    $filter: GetResidentsFilterStatusInput
  ) {
    getResidents(pagination: $pagination, sorting: $sorting, filter: $filter) {
      items {
        id
        residentId
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          spaceCode
          state
          type
          zipCode
        }
        insuranceAdoption {
          description
          status
        }
        policyType
        community {
          ctmhcId
          integrationId
          integrationType
          isActive
          legalEntityCommunityOwnerId
          name
          portfolio {
            id
            integrationId
            integrationType
            isActive
            name
          }
          displayId
          propertyId
        }
        createdAt
        updatedAt
        email
        phoneNumber
        isCurrentResident
        isPermanentlyExcluded
        wasOptedIn
        moveInDate
        moveOutDate
        sos
        isNariWorkflowApplicable
        lease {
          addendumDate
          startDate
          endDate
          description
        }
        leaseRequirements {
          animalLiabilityLimit
          leaseLimit
          medicalPaymentsLimit
        }
        policyholderLocator
        coverages {
          id
          agencyAddress
          agencyEmail
          agencyName
          agencyPhoneNumber
          annualCost
          coverageDetails {
            occupancy
            manufacturer
            homeType
            modelYear
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            homeCoverageLimit
            otherStructuresLimit
            personalLiabilityLimit
            premisesLiabilityLimit
            personalPropertyLimit
            residentLiabilityLimit
            standardDeductibleLimit
            medicalPaymentsLimit
          }
          createdAt
          documents {
            id
            name
            description
          }
          events {
            id
            type
            date
            eventData {
              agencyName
              agencyAddress
              agencyPhoneNumber
              agencyEmail
              isInternalSale
              insuranceCarrierName
              isActive
              coverageDetails {
                occupancy
                manufacturer
                homeType
                modelYear
                animalLiabilityLimit
                blanketRentalResidentLiabilityLimit
                homeCoverageLimit
                otherStructuresLimit
                personalLiabilityLimit
                premisesLiabilityLimit
                personalPropertyLimit
                residentLiabilityLimit
                standardDeductibleLimit
                medicalPaymentsLimit
              }
              policyId
              policyDescription
              termEffectiveDate
              termEndDate
              annualCost
            }
          }
          insuranceCarrierName
          isActive
          isInternalSale
          policyCancellationEffectiveDate
          policyCancellationReason
          policyDescription
          policyEffectiveDate
          policyEndDate
          policyEndReason
          policyId
          policyIssuedDate
          policyStatus
          policyType
          updatedAt
          updatedBy
        }
        physicalMailNotificationEvents {
          id
          additionalData
          eventType
          eventDate
        }
      }
      pagination {
        from
        size
        total
      }
    }
  }
`;
export const getResident = /* GraphQL */ `
  query GetResident($id: ID) {
    getResident(id: $id) {
      id
      residentId
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        spaceCode
        state
        type
        zipCode
      }
      insuranceAdoption {
        description
        status
      }
      policyType
      community {
        ctmhcId
        integrationId
        integrationType
        isActive
        legalEntityCommunityOwnerId
        name
        portfolio {
          id
          integrationId
          integrationType
          isActive
          name
        }
        displayId
        propertyId
      }
      createdAt
      updatedAt
      email
      phoneNumber
      isCurrentResident
      isPermanentlyExcluded
      wasOptedIn
      moveInDate
      moveOutDate
      sos
      isNariWorkflowApplicable
      lease {
        addendumDate
        startDate
        endDate
        description
      }
      leaseRequirements {
        animalLiabilityLimit
        leaseLimit
        medicalPaymentsLimit
      }
      policyholderLocator
      coverages {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      physicalMailNotificationEvents {
        id
        additionalData
        eventType
        eventDate
      }
    }
  }
`;
export const getPortfolios = /* GraphQL */ `
  query GetPortfolios {
    getPortfolios {
      id
      integrationId
      integrationType
      isActive
      name
    }
  }
`;
export const getParameters = /* GraphQL */ `
  query GetParameters($type: ParameterName!, $search: String!) {
    getParameters(type: $type, search: $search)
  }
`;
export const getDocumentUrl = /* GraphQL */ `
  query GetDocumentUrl($residentId: ID!, $id: ID!) {
    getDocumentUrl(residentId: $residentId, id: $id)
  }
`;
export const getCurrentUserResidents = /* GraphQL */ `
  query GetCurrentUserResidents {
    getCurrentUserResidents {
      id
      residentId
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        spaceCode
        state
        type
        zipCode
      }
      insuranceAdoption {
        description
        status
      }
      policyType
      community {
        ctmhcId
        integrationId
        integrationType
        isActive
        legalEntityCommunityOwnerId
        name
        portfolio {
          id
          integrationId
          integrationType
          isActive
          name
        }
        displayId
        propertyId
      }
      createdAt
      updatedAt
      email
      phoneNumber
      isCurrentResident
      isPermanentlyExcluded
      wasOptedIn
      moveInDate
      moveOutDate
      sos
      isNariWorkflowApplicable
      lease {
        addendumDate
        startDate
        endDate
        description
      }
      leaseRequirements {
        animalLiabilityLimit
        leaseLimit
        medicalPaymentsLimit
      }
      policyholderLocator
      coverages {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      physicalMailNotificationEvents {
        id
        additionalData
        eventType
        eventDate
      }
    }
  }
`;
export const getCommunitiesForExistingPortfolio = /* GraphQL */ `
  query GetCommunitiesForExistingPortfolio($id: ID!) {
    getCommunitiesForExistingPortfolio(id: $id) {
      ctmhcId
      integrationId
      integrationType
      isActive
      legalEntityCommunityOwnerId
      name
      portfolio {
        id
        integrationId
        integrationType
        isActive
        name
      }
      displayId
      propertyId
    }
  }
`;
export const getCommunityConfiguration = /* GraphQL */ `
  query GetCommunityConfiguration($portfolioId: ID!) {
    getCommunityConfiguration(portfolioId: $portfolioId) {
      communities {
        addressLine1
        addressLine2
        city
        ctmhcId
        defaultAddendumDate
        displayId
        isActive
        name
        ownerClientId
        propertyId
        state
        zipCode
      }
      effectiveDate
      effectiveTimestamp
      owners {
        addressLine1
        addressLine2
        city
        clientId
        county
        id
        municipality
        name
        state
        zipCode
      }
      policyDefaults {
        limits {
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          medicalPaymentsLimit
          premisesLiabilityLimit
        }
        mgaFee
        operatorFee
        pricePerUnit
      }
      portfolio {
        addressLine1
        addressLine2
        city
        county
        id
        integrationId
        integrationType
        isActive
        name
        rentManagerLocations {
          glAccountId
          id
          name
        }
        rentManagerSettings {
          liveNotesEnabled
          shouldWriteDefaultUDFValues
        }
        state
        zipCode
      }
      states {
        localTaxes {
          cityName
          cityTaxRate
          countyName
          countyTaxRate
          otherLocalTaxes {
            name
            rate
          }
          ownerClientId
        }
        policyNumbers {
          ownerClientId
          policyNumber
        }
        stampingFee
        state
        stateTax
        surplusLinesTax
      }
      taxDefaults {
        otherFee {
          name
          rate
        }
        stampingFee
        state
        stateTax
        surplusLinesTax
      }
    }
  }
`;
export const getRentManagerGeneralLedgerAccounts = /* GraphQL */ `
  query GetRentManagerGeneralLedgerAccounts(
    $portfolioId: ID!
    $locationId: Int!
  ) {
    getRentManagerGeneralLedgerAccounts(
      portfolioId: $portfolioId
      locationId: $locationId
    ) {
      description
      id
      isActive
      name
    }
  }
`;
